import {
  createErrorMessage,
  createFieldChecks,
  NO_ERRORS,
  textOrNull,
  type FieldErrors,
  type Parsed,
} from '@avrahami/ui';
import { he } from '../i18n/he';

export { NO_ERRORS, textOrNull, type FieldErrors, type Parsed };

/** A Hebrew message for any error the UI shows; `overrides` give a code a meaning in context. */
export const errorMessage = createErrorMessage(he);

const checks = createFieldChecks({
  validation: he.validation,
  invalidField: he.common.invalidField,
  required: he.common.required,
  taken: he.common.taken,
});

/** The contracts' rules and the API's refusals as messages per field (see `@avrahami/ui`). */
export const { issuesToFieldErrors, serverFieldErrors, parseWith, mergeErrors } = checks;

/** A whole number as typed: null when empty, NaN when it is not one (the schema reports it). */
export function intOrNull(text: string): number | null {
  const value = text.trim();
  if (value === '') return null;
  return /^-?\d+$/.test(value) ? Number(value) : Number.NaN;
}

/** A required whole number: NaN when empty or not a number. */
export function intOrNaN(text: string): number {
  return intOrNull(text) ?? Number.NaN;
}
